"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
const parseFormDataToJSON = formData => {
  let json = {};
  for (const [key, value] of formData.entries()) {
    json[key] = value;
  }
  return json;
};
var _default = exports.default = parseFormDataToJSON;